export default class Layer {
	constructor(id) {
		this.id = id;
		this.name = undefined;
		this.loaded = false;
		this.loading = false;
		this.style = undefined;
		this.type = undefined;
	}

	toString() {
		return this.name;
	}
}
